import type { FeatureGroup } from '../../../types';
import { CRM_INTEGRATIONS_FEATURE_GROUP } from '../group';

export const EMAIL_DESIGNER_FEATURE_GROUP: FeatureGroup = {
  guid: '38aee486-2deb-49bb-a841-0f4d6d09ff00',
  name: 'email-designer',
  description: 'Email Designer app — build branded email templates for Altru audiences',
  product: 'app',
  parentGuid: CRM_INTEGRATIONS_FEATURE_GROUP.guid,
};
